const binding = { modules: {}, dataActions: {} };

    (binding.modules['eve-locale-switcher'] = {
        c: () => require('partner/modules/eve-locale-switcher/eve-locale-switcher.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'eve-locale-switcher',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/eve-locale-switcher'
    });
        

        
    window.__bindings__ = window.__bindings__ || {};
    window.__bindings__.modules = {
        ...window.__bindings__.modules || {},
        ...binding.modules
    };
    
        window.__bindings__.dataActions = {
        ...window.__bindings__.dataActions || {},
        ...binding.dataActions
    };
                        export const viewDictionary = {};
                        viewDictionary['__local__|__local__|modules|eve-locale-switcher|eve-locale-switcher'] = {
                c: () => require('partner/modules/eve-locale-switcher/eve-locale-switcher.view.tsx'),
                cn: '__local__-__local__-eve-locale-switcher'
            };
window.__bindings__ = window.__bindings__ || {};
window.__bindings__.viewDictionary = {
                        ...window.__bindings__.viewDictionary || {},
                        ...viewDictionary
                    };